module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('app-header', [_c('app-nav')], 1), _vm._v(" "), _c('section', {
    staticClass: "container"
  }, [_vm._m(0), _vm._v(" "), _c('ul', {
    staticClass: "nav nav-tabs"
  }, [_vm._m(1), _vm._v(" "), _vm._l((_vm.escaloes), function(escalao) {
    return _c('li', {
      attrs: {
        "role": "presentation"
      }
    }, [_c('a', {
      attrs: {
        "data-toggle": "tab",
        "href": '#' + escalao
      }
    }, [_vm._v(_vm._s(escalao))])])
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)], 2), _vm._v(" "), _c('div', {
    staticClass: "tab-content"
  }, [_c('div', {
    staticClass: "tab-pane fade in active",
    attrs: {
      "id": "Geral"
    }
  }, [_c('tabela-completa', {
    attrs: {
      "dados": _vm.tabelaTrail,
      "num": _vm.tabelaTrail.length
    }
  })], 1), _vm._v(" "), _vm._l((_vm.escaloes), function(escalao) {
    return _c('div', {
      staticClass: "tab-pane fade in",
      attrs: {
        "id": escalao
      }
    }, [(_vm.tabelaEscalao(escalao)) ? _c('tabela', {
      attrs: {
        "dados": _vm.tabelaEscalao(escalao),
        "num": _vm.tabelaEscalao(escalao).length
      }
    }) : _vm._e()], 1)
  }), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "Equipas"
    }
  }, [_c('h3', [_vm._v("Pontuação por equipa")]), _vm._v(" "), _c('tabela-equipas', {
    attrs: {
      "dados": _vm.tabelaEquipasPontos,
      "num": _vm.tabelaEquipasPontos.length
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Equipas por número de participantes")]), _vm._v(" "), _c('tabela-equipas-participantes', {
    attrs: {
      "dados": _vm.tabelaEquipas,
      "num": _vm.tabelaEquipas.length
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "tab-pane fade in",
    attrs: {
      "id": "Premiados"
    }
  }, [_c('h3', [_vm._v("Geral Masculina")]), _vm._v(" "), _c('tabela-completa', {
    attrs: {
      "dados": _vm.tabelaSexo('M'),
      "num": 3
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Geral Feminina")]), _vm._v(" "), _c('tabela-completa', {
    attrs: {
      "dados": _vm.tabelaSexo('F'),
      "num": 3
    }
  }), _vm._v(" "), _vm._l((_vm.escaloes), function(escalao) {
    return _c('div', [_c('h3', [_vm._v(_vm._s(escalao))]), _vm._v(" "), _c('tabela', {
      attrs: {
        "dados": _vm.tabelaEscalao(escalao),
        "num": 3
      }
    })], 1)
  }), _vm._v(" "), _c('h3', [_vm._v("Geral Feminina")]), _vm._v(" "), _c('tabela-completa', {
    attrs: {
      "dados": _vm.tabelaTrail,
      "num": 3
    }
  }), _vm._v(" "), _vm._l((_vm.escaloes), function(escalao) {
    return _c('div', [_c('h3', [_vm._v(_vm._s(escalao))]), _vm._v(" "), _c('tabela', {
      attrs: {
        "dados": _vm.tabelaEscalao(escalao),
        "num": 3
      }
    })], 1)
  }), _vm._v(" "), _c('h3', [_vm._v("Equipas - Pontuação")]), _vm._v(" "), _c('tabela-equipas', {
    attrs: {
      "dados": _vm.tabelaEquipasPontos,
      "num": 5
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Equipas - Participantes")]), _vm._v(" "), _c('tabela-equipas-participantes', {
    attrs: {
      "dados": _vm.tabelaEquipas,
      "num": 1
    }
  })], 2)], 2)])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-header"
  }, [_c('h2', [_vm._v("Resultados")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "active",
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#Geral"
    }
  }, [_vm._v("Geral")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#Equipas"
    }
  }, [_vm._v("Equipas")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    attrs: {
      "role": "presentation"
    }
  }, [_c('a', {
    attrs: {
      "data-toggle": "tab",
      "href": "#Premiados"
    }
  }, [_vm._v("Premiados")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-440e52cb"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/pub/Resultados.vue
// module id = 255
// module chunks = 1